import TeamSpaceTabs from './TeamSpaceTabs';
import TrendFilters from './filters/TrendFilters/TrendFilters';
import { TEAM_SPACE_TABS } from '../team-space.consts';
import DaysLeft from './components/DaysLeft';
import TreeTeamsDropdown from 'components/teams/TreeTeamsDropdown/TreeTeamsDropdown';
import IterationsPicker from './filters/IterationsPicker';
import useTeamSpaceTrackingEvents from '../useTeamSpace/useTeamSpaceTrackingEvents';
import { getObjKeyByValue } from 'common/utils/utils';
import { SUMMARY_PERIODS } from '../../../projects/ProjectsApi/projects.consts';
import useCloseIterationSummary from 'components/IterationSummary/useCloseIterationSummary';

const TeamSpaceHeader = ({ teamSpace }) => {
  const { selectedTab, selectedTeam, emptyStateType } = teamSpace;
  const isEmptyState = !!emptyStateType;
  const trackingEvents = useTeamSpaceTrackingEvents({ selectedTab });
  const { onCloseIterationSummary } = useCloseIterationSummary();

  const onClickTab = newTab => {
    onCloseIterationSummary();
    trackingEvents.onTabClick(newTab);
    teamSpace.setSelectedTab(newTab);
  };

  const onTeamChange = selectedTeams => {
    onCloseIterationSummary();
    const newTeam = selectedTeams[0];
    trackingEvents.onTeamChange(newTeam?.id);
    teamSpace.setSelectedTeam(newTeam);
  };

  const onPdtIterationChange = pdtIteration => {
    onCloseIterationSummary();
    trackingEvents.onIterationChange(pdtIteration.id);
    teamSpace.setSelectedPdtIteration(pdtIteration);
  };

  const onTrendDurationChange = trendDuration => {
    const trendDurationKey = getObjKeyByValue(SUMMARY_PERIODS, trendDuration);
    trackingEvents.onTrendDurationChange(trendDurationKey);
    teamSpace.setTrendDuration(trendDuration);
  };

  return (
    <div className='m-3 mb-0 flex flex-row items-center gap-4 bg-white p-3'>
      <TeamSpaceTabs value={selectedTab} onChange={onClickTab} />
      <TreeTeamsDropdown
        width='20rem'
        selectedTeamIds={[selectedTeam?.id]}
        onChange={onTeamChange}
        customPlaceholder={!selectedTeam ? () => 'Select a team' : null}
        isSelectRootEnabled={false}
        isShowAllTeams={false}
        isHideAllTeamsGroup={true}
        isHideAllContributors={true}
        isAllowNoDefault={true}
        isOpenParentsOfSelected
        isGroupSelectionDisabled={true}
        isFilterTreeBySelectRoot={false}
        size='small'
      />
      {selectedTab === TEAM_SPACE_TABS.CURRENT && !isEmptyState && (
        <>
          {teamSpace.activeIterations?.length > 1 && (
            <IterationsPicker
              iterations={teamSpace.activeIterations}
              selectedIteration={teamSpace.activeIteration}
              onChange={teamSpace.setActiveIteration}
              disabled={isEmptyState}
            />
          )}
          <DaysLeft
            activeIteration={teamSpace.activeIteration}
            selectedTeam={selectedTeam}
          />
        </>
      )}
      {selectedTab === TEAM_SPACE_TABS.COMPLETED && (
        <IterationsPicker
          iterations={teamSpace.pdtIterations}
          selectedIteration={teamSpace.selectedPdtIteration}
          onChange={onPdtIterationChange}
          disabled={isEmptyState}
        />
      )}
      {selectedTab === TEAM_SPACE_TABS.TREND && (
        <TrendFilters
          duration={teamSpace.trendDuration}
          setDuration={onTrendDurationChange}
          disabled={isEmptyState}
        />
      )}
    </div>
  );
};

export default TeamSpaceHeader;
